<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex';

    
export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        save: function(){
        },
        archive: function(response){
        },
        confirmArchive: function(item){
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        clearForm: function(){
            this.data = {};
        }
    }
}
</script>
